/**
 * WorkflowStatusBadge Component
 * Displays the current status of a workflow with appropriate styling
 */

interface WorkflowStatusBadgeProps {
  status: 'active' | 'paused' | 'error' | 'completed';
}

export function WorkflowStatusBadge({ status }: WorkflowStatusBadgeProps) {
  const badgeClasses = {
    active: 'badge-success',
    paused: 'badge-warning',
    error: 'badge-error',
    completed: 'badge-info',
  };

  const labels = {
    active: 'Active',
    paused: 'Paused',
    error: 'Error',
    completed: 'Completed',
  };

  return (
    <span class={`badge ${badgeClasses[status]}`}>
      {labels[status]}
    </span>
  );
}
